export const POLK_ATTRIBUTION_QUERY = {
    view: "explore_polk_attribution",
    fields: [],
    filters: {
        "polk_attribution.flt_analysis_interval": "",
        "polk_attribution.pmt_lookback_window": ""
    },
    limit: "-1",
    column_limit: "50",
    model: "client_analytics"
};
//# sourceMappingURL=query.js.map